import PropTypes from 'prop-types';
import React from 'sitewide-react';
import RedesignedMentionsPing from './redesigned_mentions_ping';

class MentionsRetriggerPing extends RedesignedMentionsPing {
  getBody() {
    const article = $h.aOrAn(this.props.researchInterestName);

    return (
      <div className="text">
        The name <strong>{this.props.mentionedName}</strong> is{' '}
        {this.mentionVerb()} in {article}{' '}
        <strong>{this.props.researchInterestName}</strong> paper uploaded to
        Academia.
      </div>
    );
  }

  getUpgradeURL() {
    return $r.upgrade_url({
      feature: 'searchm',
      trigger: 'mentions-retrigger-onsite-ping',
      after_upgrade_path: encodeURIComponent($r.mentions_path()),
    });
  }
}

MentionsRetriggerPing.propTypes = {
  mentionedName: PropTypes.string.isRequired,
  researchInterestName: PropTypes.string.isRequired,
};

export default MentionsRetriggerPing;
